var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13258_211285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76244 10.511H4.61271V10.5018C4.61271 7.29929 7.16815 4.60466 10.4271 4.61978C12.0159 4.62697 13.4755 5.26882 14.5156 6.31819L16.4128 4.48793C14.8811 2.94309 12.7647 1.98828 10.4271 1.98828C5.7559 1.98828 1.96932 5.80247 1.96271 10.5097H0.799848C0.0871529 10.5097 -0.204224 10.9862 0.152124 11.5696L2.63342 14.0292C3.12558 14.5214 3.42158 14.5365 3.92887 14.0292L6.41016 11.5696C6.76651 10.9868 6.47447 10.511 5.76244 10.511ZM20.8478 9.48722L18.3665 7.0328C17.8605 6.52683 17.5475 6.55701 17.0717 7.0328L14.5904 9.48722C14.234 10.0693 14.5247 10.5458 15.2374 10.5458H16.3853C16.3669 13.7273 13.82 16.3983 10.5722 16.3831C8.98403 16.3766 7.52516 15.7361 6.48372 14.6874L4.5865 16.5151C6.11886 18.0573 8.23529 19.0108 10.5722 19.0108C15.2289 19.0108 19.0051 15.2242 19.0353 10.5464H20.2001C20.9134 10.5458 21.2041 10.0687 20.8478 9.48722Z",
    fill: "#FF9B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13258_211285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.6bf7d083a2c53cad97dcb1411f6c2bbb.svg";
export { ForwardRef as ReactComponent };